import { useState, useCallback, ReactNode } from "react";
import OrderHistoryPaginationState from "../interfaces/OrderHistoryPagination";
import { DEFAULT_PAGE_NUMBER, PAGINATION_PAGE_SIZE_OPTIONS } from "../constants/constants";
import OrderHistoryTableContextType from "../interfaces/context/OrderHistoryTableContext";
import { OrderHistoryTableContext } from "../context/OrderHistoryTableContext";

export const initialPaginationState: OrderHistoryPaginationState = {
  page: DEFAULT_PAGE_NUMBER,
  pageSize: PAGINATION_PAGE_SIZE_OPTIONS[0],
};

export const OrderHistoryTableProvider = ({ children }: { children: ReactNode }) => {
  const [pagination, setPagination] = useState<OrderHistoryPaginationState>(initialPaginationState);
  const [totalCount, setToalCount] = useState<number>(0);

 const updatePagination = useCallback(
    (page?: number, pageSize?: number) => {
      setPagination((prev) => ({
        page: page ?? prev.page,
        pageSize: pageSize ?? prev.pageSize,
      }));
    },
    []
  );

   const updateTotalCount = useCallback(
    (totalCount: number) => {
      setToalCount(totalCount);
    },
    []
  );

  const resetPagination = useCallback(() => {
    setPagination(initialPaginationState);
  }, []);

  const contextValue: OrderHistoryTableContextType = {
    pagination,
    totalCount,
    updatePagination,
    resetPagination,
    updateTotalCount
  };

  return (
    <OrderHistoryTableContext.Provider value={contextValue}>
      {children}
    </OrderHistoryTableContext.Provider>
  );
};
